export const FILTER_SAVED = 'partner/filter_saved';
